import { createFileRoute } from '@tanstack/react-router'
import { NovedadesPage } from '@/features/announcements/components/NovedadesPage'

export const Route = createFileRoute('/_auth/novedades')({
  // ?id=<uuid> deep-link from the topbar bell opens that announcement.
  validateSearch: (search: Record<string, unknown>): { id?: string } => ({
    id: typeof search.id === 'string' ? search.id : undefined,
  }),
  component: RouteComponent,
})

// eslint-disable-next-line react-refresh/only-export-components
function RouteComponent() {
  const { id } = Route.useSearch()
  return <NovedadesPage initialId={id} />
}
